/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

// import React from 'react';
// import env from "react-dotenv"
import { LogLevel } from "@azure/msal-browser";

/**
 * Enter here the user flows and custom policies for your B2C application
 * To learn more about user flows, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/user-flow-overview
 * To learn more about custom policies, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/custom-policy-overview
 */
export const b2cPolicies = {
    names: {
//        signUpSignIn: 'B2C_1_sign_up_sign_in_1',
        forgotPassword: 'B2C_1_reset_password_1',
//        editProfile: 'B2C_1_edit_profile_1',
//        signUp: 'B2C_1_sign_up_1',
        signIn: 'B2C_1_sign_in_1',
    },
    authorities: {
//         signUpSignIn: {
//             authority: 'https://csvcpm.b2clogin.com/csvcpm.onmicrosoft.com/B2C_1_sign_up_sign_in_1',
//         },
         forgotPassword: {
             authority: 'https://csvcpm.b2clogin.com/csvcpm.onmicrosoft.com/B2C_1_reset_password_1',
         },
//         editProfile: {
//             authority: 'https://csvcpm.b2clogin.com/csvcpm.onmicrosoft.com/B2C_1_edit_profile_1',
//         },
//         signUp: {
//             authority: 'https://csvcpm.b2clogin.com/csvcpm.onmicrosoft.com/B2C_1_sign_up_1',
//         },
        signIn: {
            authority: 'https://csvcpm.b2clogin.com/csvcpm.onmicrosoft.com/B2C_1_sign_in_1',
        },
    },
    authorityDomain: 'csvcpm.b2clogin.com',
};

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */
export const msalConfig = {
    auth: {
        authority: b2cPolicies.authorities.signIn.authority, // Choose SI as your default authority.
        // authority: b2cPolicies.authorities.signUpSignIn.authority, // Choose SUSI as your default authority. // In uso sino al 12/03/2025
        knownAuthorities: [b2cPolicies.authorityDomain], // Mark your B2C tenant's domain as trusted.

        clientId: '0deddacb-4d04-4a6c-aa56-a902ab55c880', // (csvc-spa-v1) This is the ONLY mandatory field that you need to supply.

            redirectUri: 'https://csvc.it/app', // You must register this URI on Azure Portal/App Registration. Defaults to window.location.origin
            postLogoutRedirectUri: 'https://csvc.it', // Indicates the page to navigate after logout.

            // ? FORSE NON E' NECESSARIO UN DIVERSO ID CLIENT ? // clientId: '7cda4de5-38a5-4651-858c-28a574d17996', // (csvc-spa-v1-localhost IdClient) This is the ONLY mandatory field that you need to supply.
            // redirectUri: 'http://localhost:3000/app', // You must register this URI on Azure Portal/App Registration. Defaults to window.location.origin
            // postLogoutRedirectUri: 'https://csvc.it', // Indicates the page to navigate after logout.
            
            
        navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
    },
    cache: {
        cacheLocation: 'sessionStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            },
        },
    },
};

/**
 * Add here the endpoints and scopes when obtaining an access token for protected web APIs. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const protectedResources = {
    apiTodoList: {
        endpoint: 'http://localhost:5000/api/todolist',
        scopes: {
            read: ['https://csvcpm.onmicrosoft.com/area51-api/area51-api.read'],
            write: ['https://csvcpm.onmicrosoft.com/area51-api/area51-api.write'],
        },
    },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: [...protectedResources.apiTodoList.scopes.read, ...protectedResources.apiTodoList.scopes.write],
};
